// Module
var code = "<div class=vb-space-slot-container><label>Select start time</label><button class=\"btn btn-small\" ng-repeat=\"time in $ctrl.currentAvailability.times track by $index\" ng-class=\"{ 'btn-selected-time': $ctrl.request.data.time === time }\" ng-click=$ctrl.selectTime(time)>{{time | numberToTime | convertMoment:'H:m':'h:mma'}}</button></div>";
// Exports
module.exports = code;